import React from 'react';
import './estilo.scss';
import 'materialize-css/dist/css/materialize.min.css'
import logo from '../../assets/logo.png'
import { Link } from "react-scroll";


function Menu() {
    return (

        <nav>
            <div className="nav-wrapper teste">
                <a href="/" ><img className="brand-logo logo" alt="logo" src={logo}></img></a>
                <ul id="nav-mobile" className="right hide-on-med-and-down nav-menu">
                    <Link
                        activeClass="active"
                        to="aboutme"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        About me
                    </Link>
                    <Link
                        activeClass="active"
                        to="skills"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        Skills
                    </Link>
                    <Link
                        activeClass="active"
                        to="experience"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >
                        Experience
                    </Link>
                </ul>
            </div>
        </nav>

    );
}

export default Menu;
